import * as actionTypes from "../actionTypes";
import axios from "../../middleware/axios-api";
import { formatBase64Image, getErrors, getResData } from "../../shared/utility";

// Get Categories
export const getCategoryStart = () => {
  return {
    type: actionTypes.GET_CATEGORY_START,
    categories: null,
  };
};

export const getCategorySuccess = (categories: any) => {
  return {
    type: actionTypes.GET_CATEGORY_SUCCESS,
    categories,
  };
};

export const getCategoryFailed = (error: any) => {
  return {
    type: actionTypes.GET_CATEGORY_FAIL,
    error,
    categories: null,
  };
};

export const getCategory = ({data, signal, t}: any) => {
  return async (dispatch: any) => {
    dispatch(getCategoryStart());

    return axios
      .post(`/categories` , data, {signal})
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          let data = getResData(response.data);          
          if (!data.success) throw new Error(getErrors(data));
          const categoryList = data?.data?.items?.map((item:any) => ({value: item.id, label: item.name, iconId: item.iconId}))
          
          if(categoryList) categoryList.unshift({value: null, label: t('landing_46')});
          if(data?.data?.items && categoryList) data.data.items = categoryList;

          return dispatch(getCategorySuccess(data.data));
        }
      })
      .catch((err) => dispatch(getCategoryFailed(getErrors(err))));
  };
};

// Load category icon
export const loadCategoryIconStart = () => {
  return {
    type: actionTypes.LOAD_CATEGORY_ICON_START,
    categories: null,
  };
};

export const loadCategoryIconSuccess = (categoryIcon: any) => {
  return {
    type: actionTypes.LOAD_CATEGORY_ICON_SUCCESS,
    categoryIcon,
  };
};

export const loadCategoryIconFail = (error: any) => {
  return {
    type: actionTypes.LOAD_CATEGORY_ICON_FAIL,
    error,
    categories: null,
  };
};

export const loadCategoryIcon = ({ iconId, signal }: any) => {
  return async (dispatch: any) => {
    dispatch(loadCategoryIconStart());

    return axios
      .get(`/category/icon/load/${iconId}`, { signal })
      .then((response) => {
        if (!response) throw new Error("No Response");

        let data;
        if (response.data.data) {
          data = formatBase64Image(response.data.data);
        }
        return dispatch(loadCategoryIconSuccess({ data, iconId }));
      })
      .catch((err) => dispatch(loadCategoryIconFail(getErrors(err))));
  };
};

// Get Sub-Categories
export const getSubCategoryStart = () => {
  return {
    type: actionTypes.GET_SUBCATEGORY_START,
    subcategories: null,
  };
};

export const getSubCategorySuccess = (subcategories: any) => {
  return {
    type: actionTypes.GET_SUBCATEGORY_SUCCESS,
    subcategories,
  };
};

export const getSubCategoryFailed = (error: any) => {
  return {
    type: actionTypes.GET_SUBCATEGORY_FAIL,
    error,
    subcategories: null,
  };
};

export const getSubCategory = (data: any) => {
  return async (dispatch: any) => {
    dispatch(getSubCategoryStart());

    return axios
      .post(`/subcategories` , data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);          
          if (!data.success) throw new Error(getErrors(data));

          const subCategoryList = data?.data?.items?.map((item:any) => ({value: item.id, label: item.name}))
          if(data?.data?.items && subCategoryList) data.data.items = subCategoryList;

          return dispatch(getSubCategorySuccess(data.data));
        }
      })
      .catch((err) => dispatch(getSubCategoryFailed(getErrors(err))));
  };
};

// Get Subscription Categories
export const getSubscriptionCategoryStart = () => {
  return {
    type: actionTypes.GET_SUBSCRIPTION_CATEGORY_START,
    categories: null,
  };
};

export const getSubscriptionCategorySuccess = (categories: any) => {
  return {
    type: actionTypes.GET_SUBSCRIPTION_CATEGORY_SUCCESS,
    categories,
  };
};

export const getSubscriptionCategoryFailed = (error: any) => {
  return {
    type: actionTypes.GET_SUBSCRIPTION_CATEGORY_FAIL,
    error,
    categories: null,
  };
};

export const getSubscriptionCategory = ({data, signal}: any) => {
  return async (dispatch: any) => {
    dispatch(getSubscriptionCategoryStart());

    return axios
      .post(`/buyer/categories`, data, {signal})
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          let data = getResData(response.data);          
          if (!data.success) throw new Error(getErrors(data));
          const categoryList = data?.data?.items?.map((item:any) => ({value: item.id, label: item.name, subscribed: item.subscribed}))
          
          if(data?.data?.items && categoryList) data.data.items = categoryList;

          return dispatch(getSubscriptionCategorySuccess(data.data));
        }
      })
      .catch((err) => dispatch(getSubscriptionCategoryFailed(getErrors(err))));
  };
};